export const types = {
  SET_CART_ITEMS: 'SET_CART_ITEMS',
  SET_CART_ID: 'SET_CART',
  SET_CART_ID_FROM_COOKIE: 'SET_CART_ID_FROM_COOKIE',
  SET_APPLIED_COUPONS: 'SET_APPLIED_COUPONS',
  SET_APPLIED_GIFT_CARDS: 'SET_APPLIED_GIFT_CARDS',
  SET_CART_ATTACHMENTS: 'SET_CART_ATTACHMENTS',
  SET_CART_PRICES: 'SET_CART_PRICES',
  SET_CART_MEDICLUB_PRICES: 'SET_CART_MEDICLUB_PRICES',
  SET_CART_NO_MEDICLUB_PRICES: 'SET_CART_NO_MEDICLUB_PRICES',
  SET_CART_RESERVATION_INTERVAL: 'SET_CART_RESERVATION_INTERVAL',
  SET_CART_RESERVATION_TIMEOUT: 'SET_CART_RESERVATION_TIMEOUT',
  SET_CART_REMOVED_ITEMS: 'SET_CART_REMOVED_ITEMS',
  UPDATE_CART_RESERVATION_TIME: 'UPDATE_CART_RESERVATION_TIME',
  SET_CURRENT_STEP: 'SET_CURRENT_STEP',
  SET_CART_LOADED: 'SET_CART_LOADED',
  REMOVE_CART_ITEMS: 'REMOVE_CART_ITEMS',
  RESET_CART: 'RESET_CART',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  SET_SELECTED_PAYMENT: 'SET_SELECTED_PAYMENT',
  SET_CUSTOMER_EMAIL: 'SET_CUSTOMER_EMAIL',
  IS_REGISTERED_ON_CHECKOUT: 'IS_REGISTERED_ON_CHECKOUT',
  IS_CART_READ_ONLY: 'IS_CART_READ_ONLY',
  SET_SHIPPING_METHOD_READ_ONLY: 'SET_SHIPPING_METHOD_READ_ONLY',
  SET_BILLING_ADDRESS: 'SET_BILLING_ADDRESS',
  SET_PAYMENT_METHOD_ID: 'SET_PAYMENT_METHOD_ID',
  SET_AVAILABLE_PAYMENT_METHODS: 'SET_AVAILABLE_PAYMENT_METHODS',
}
